import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteMaintenanceSchedule($companyId: ID!, $id: ID!) {
    deleteMaintenanceSchedule(companyId: $companyId, id: $id) {
      maintenanceSchedule {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
